import {api} from '@/http'

// 图片列表
const getPicList = (data, callback, back) => {
  api('/api/PicView/List', 'post', data, callback, back)
}

// 图片添加
const addPicView = (data, callback, back) => {
  api('/api/PicView/Insert', 'post', data, callback, back)
}

// 图片删除
const delPicView = (id, callback, back) => {
  api('/api/PicView/Delete', 'post', {Id: id}, callback, back)
}

// 图片预览
const lookPicView = (id, callback, back) => {
  api('/api/PicView/View', 'post', {Id: id}, callback, back)
}

export default {
  getPicList,
  addPicView,
  delPicView,
  lookPicView
}



// WEBPACK FOOTER //
// ./src/api/tool/index.js